import axios from "axios";

export const BaseURL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

export const CDN_BASE = process.env.REACT_APP_CDN_URL || "https://cdn.jagratiedu.com";

export const IconsPath = `${CDN_BASE}/task_objects/task_group_icons/`;

export const Server = axios.create({
  baseURL: BaseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
    Partner: "Jagrati",
    Source: "User",
  },
});

export const SetAuthToken = (token) => {
  if (token) {
    Server.defaults.headers.common.Token = token;
  } else {
    delete Server.defaults.headers.common.Token;
  }
};

export const ApiPaths = {
  REGISTER: "user/add",
  LOGIN: "user/login",
  SENT_OTP: "user/sendLoginOtp",
  VERIFY_OTP: "user/verifyLoginOtp",
  VERIFY_MASTER_PASSWORD: "user/verifyMasterPassword",
  UPDATE_PROFILE: "user/updateUserDetails",
  GET_DAY_STATUS: "task/getDayDone/", // User UID
  GET_TASK_GROUPS: "task/taskGroupForUser",
  GET_NEXT_TASK: "task/getNextTaskGroupForUser",
  GET_TASK_DETAILS: "task/getTaskGroupDetailsById/",
  GET_TASK_QUESTIONS: "task/taskForUser",
  SUBMIT_ANSWERS: "task/submitTaskGroupResponse/",
  UPLOAD_FILE: "util/file/upload",
  GET_TASK_PLANS: "task/getTaskPlans",
  CREATE_ORDER: "payment/createOrder",
  PAYMENT_SUCCESS: "payment/onPaymentSuccess/",
  UPDATE_USER_PLAN: "user/updateUserPlan",
};
